<template>
  <b-dropdown
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    size="sm"
    text="Validar manualmente"
    variant="primary"
  >
    <b-dropdown-item @click="$emit('revalidate', 'validateDependencies')">
      Dependencias
    </b-dropdown-item>
    <b-dropdown-item @click="$emit('revalidate', 'validatePosition')">
      Puesto / Cargo
    </b-dropdown-item>
    <b-dropdown-item @click="$emit('revalidate', 'validateGrade')">
      Grado
    </b-dropdown-item>
    <b-dropdown-item @click="$emit('revalidate', 'validateDepartment')">
      Departamento
    </b-dropdown-item>
    <b-dropdown-item @click="$emit('revalidate', 'validateEfTitulacion')">
      Entidad Federativa de titulación
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { BDropdown, BDropdownItem } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  emits: ['revalidate', 'revalidate-all'],
  components: {
    BDropdown,
    BDropdownItem,
  },
  directives: {
    Ripple,
  },
}
</script>
